const TemperaturePerLocation = () => import('@/views/market/informations/TemperaturePerLocation')
const TemperaturePerLocationTimeRange = () => import('@/views/market/informations/TemperaturePerLocationTimeRange')
const RainFallPerLocation = () => import('@/views/market/informations/RainFallPerLocation')
const TemperatureForcastPerLocation = () => import('@/views/market/informations/TemperatureForcastPerLocation')

const mainWidget = [
  {
    title: 'กราฟแสดงอุณหภูมิในแต่ละช่วงเวลาพื้นที่',
    path: '/admin/widget/:category/:widget_code(95)',
    component: TemperaturePerLocationTimeRange
  },
  {
    title: 'แผนที่แสดงอุณหภูมิเฉลี่ยในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(96)',
    component: TemperaturePerLocation
  },
  {
    title: 'แผนที่แสดงปริมาณน้ำฝนในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(97)',
    component: RainFallPerLocation
  },
  {
    title: 'แผนที่แสดงอากาศในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(98)',
    component: TemperatureForcastPerLocation
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})